export default __webpack_public_path__ + "static/media/v1.ddeaed2a.svg";